import { useSyncExternalStore } from "react";
import { api } from "@/lib/api";

let frames = {};
let loaded = false;
const subs = new Set();
const emit = () => subs.forEach((f) => f());

const fetchFrames = () => api.get("/level-frames").then(({ data }) => { frames = data || {}; emit(); });
const load = () => {
  if (loaded) return;
  loaded = true;
  fetchFrames().catch(() => { loaded = false; });
  setInterval(() => document.visibilityState === "visible" && fetchFrames().catch(() => {}), 5 * 60 * 1000);
};
const subscribe = (f) => { subs.add(f); load(); return () => subs.delete(f); };

export const useLevelFrame = (id) => useSyncExternalStore(subscribe, () => (id && frames[id]) || 0);

export async function wearFrame(userId, level) {
  const { data } = await api.put("/me/level-frame", { level });
  frames = { ...frames }; if (data.level_frame) frames[userId] = data.level_frame; else delete frames[userId];
  emit();
  return data;
}
